export const meta = {
  appAlias: 'slider',
  appName: 'Slider'
};
